import ProductUsageImpactPerType from "@/components/drawers/ProductDrawer/ProductUsageImpactPerType";
import ProductUsageImpactTopContributing from "@/components/drawers/ProductDrawer/ProductUsageImpactTopContributing";
import NoImpactBanner from "@/components/NoImpactBanner/NoImpactBanner";
import { useDashboardYear } from "@/pages/dashboard/hooks/useDateRange";
import { useDashboardOrderCounts } from "@/pages/dashboard/hooks/usePoSo";
import { ProductBy, useProductUsageImpactPerType } from "@/pages/dashboard/hooks/useProductImpact";
import { ImpactMetric } from "@/pages/dashboard/utils/types";
import { Col, Row } from "antd";
import { Link } from "react-router-dom";

function UsagePerProduct({
  metric,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const { data } = useProductUsageImpactPerType({ productId, by, metric: metric.key });

  const { data: orderCounts } = useDashboardOrderCounts({ productId });
  const { year } = useDashboardYear();

  if (orderCounts?.po === 0) {
    return (
      <NoImpactBanner title={`No usage impact for this product in ${year}`}>
        <span>
          This product was not found in any <strong>purchase orders</strong> in {year}, so no impact
          could be calculated. Navigate to a different year, or upload{" "}
          <Link to="/orders/purchase_orders">purchase orders</Link>.
        </span>
      </NoImpactBanner>
    );
  }

  if (data?.impact_per_type.length === 0) {
    return (
      <NoImpactBanner
        title={`No usage impact`}
        size="small"
      >
        <span>
          Check if you've uploaded data about the{" "}
          <Link to={`/products/${productId}/usage`}>usage</Link> phase of this product.
        </span>
      </NoImpactBanner>
    );
  }

  return (
    <Row gutter={[10, 10]}>
      <Col span={12}>
        <ProductUsageImpactTopContributing
          productId={productId}
          metric={metric}
          by={by}
        />
      </Col>
      <Col span={12}>
        <ProductUsageImpactPerType
          productId={productId}
          metric={metric}
          by={by}
        />
      </Col>
    </Row>
  );
}

export default UsagePerProduct;
